import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { css } from '@emotion/core';

import { stylingHelpers } from '../../designTokens';
import Image from '../chrome/Image';
import Frame from '../chrome/Frame';
import Text from '../chrome/Text';

const { flexCenter } = stylingHelpers;

const containerBaseStyles = () => css`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const containerPlaceholderStyles = ({ theme, isPlaceholder }) =>
  isPlaceholder &&
  css`
    background-color: ${theme.colors.n500};
  `;

const Container = styled('div')(containerBaseStyles, containerPlaceholderStyles);

const imageWrapperBaseStyles = () => css`
  overflow: hidden;
  ${flexCenter()};

  svg {
    width: 100%;
    height: 100%;
  }
`;

const ImageWrapper = styled('div')(imageWrapperBaseStyles);

const textWrapperBaseStyles = ({ theme }) => css`
  margin-left: ${theme.spacings.byte};
`;

const TextWrapper = styled('div')(textWrapperBaseStyles);

const ImageWithFrame = ({ assetUrl, assetAlt, text, ...props }) => (
  <Container>
    <Frame {...props}>
      {assetUrl && (
        <ImageWrapper>
          <Image src={assetUrl} assetAlt={assetAlt} />
        </ImageWrapper>
      )}
    </Frame>

    {text && (
      <TextWrapper>
        <Text as='span' size='mega' noMargin>
          {text}
        </Text>
      </TextWrapper>
    )}
  </Container>
);

ImageWithFrame.propTypes = {
  assetUrl: PropTypes.string,
  assetAlt: PropTypes.string,
  text: PropTypes.string,
};

export default ImageWithFrame;
